import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, User, Home, CreditCard } from 'lucide-react';

const SignUpProgressBar = ({ currentStage, totalStages }) => {
  const { t } = useTranslation('signup');

  const stages = [
    { id: 1, name: t('personal_info'), icon: User },
    { id: 2, name: t('address_info'), icon: Home },
    { id: 3, name: t('bank_account'), icon: CreditCard }
  ];

  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        {stages.map((stage, index) => {
          const Icon = stage.icon;
          const isCompleted = currentStage > stage.id;
          const isActive = currentStage === stage.id;
          const isLast = index === stages.length - 1;

          return (
            <React.Fragment key={stage.id}>
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-12 h-12 rounded-full flex items-center justify-center transition-colors
                    ${isCompleted ? 'bg-green-500 text-white' : 
                      isActive ? 'bg-blue-500 text-white' : 
                      'bg-gray-200 text-gray-500'}
                  `}
                >
                  {isCompleted ? (
                    <Check className="w-6 h-6" />
                  ) : (
                    <Icon className="w-6 h-6" />
                  )}
                </div>
                <span 
                  className={`
                    mt-2 text-xs sm:text-sm font-medium text-center
                    ${isActive ? 'text-blue-600' : 
                      isCompleted ? 'text-green-600' : 
                      'text-gray-500'}
                  `}
                >
                  {stage.name}
                </span>
              </div>
              
              {!isLast && (
                <div className="flex-1 mx-4">
                  <div className="h-1 bg-gray-200 rounded-full">
                    <div
                      className={`
                        h-full rounded-full transition-all duration-300
                        ${currentStage > stage.id ? 'bg-green-500' : 'bg-gray-200'}
                      `}
                      style={{
                        width: currentStage > stage.id ? '100%' : '0%'
                      }}
                    />
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default SignUpProgressBar;